import React from 'react';
import {
  Badge,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Text,
} from '@razorpay/blade/components';
import HeaderSection from './HeaderSection';

const ArrearsInfo = () => {
  return (
    <Box>
      <HeaderSection
        title={'Calculate Arrears'}
        description={`Choose whether the component can generate arrears. Arrears occur when past deductions need to be adjusted due to changes like LOP reversals. It ensures accurate recovery or refund of deduction amounts.`}
      />

      <Divider marginY={'spacing.7'} />

      <Box display={'flex'} flexDirection={'column'}>
        <Text weight={'semibold'}>
          If Arrear calculation is{'  '}
          <Badge emphasis={'subtle'} color={'positive'}>
            Enabled
          </Badge>
        </Text>
        <Box display={'flex'} flexDirection={'column'} gap={'spacing.4'}>
          <Text size="small" color={'surface.text.gray.muted'}>
            The system will automatically adjust deductions for past periods if there's a change,
            like an LOP reversal.
          </Text>
          <Text size="small" color={'surface.text.gray.muted'}>
            Example:
          </Text>
          <List size={'small'} variant={'unordered'}>
            <ListItem>
              <ListItemText color={'surface.text.gray.muted'}>
                An employee was marked with 4 LOP days in January, resulting in a Canteen Charges
                deduction of ₹433 (prorated from ₹500 for 26 working days instead of 30).
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText color={'surface.text.gray.muted'}>
                In March, 2 LOP days were reversed as the leave was approved retrospectively,
                updating January's working days to 28.
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText color={'surface.text.gray.muted'}>
                If arrears are enabled for the Canteen Charges component, an additional ₹33 will be
                deducted in March (difference between the corrected deduction of ₹467 and the
                original ₹433).
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Box>

      <Divider marginY={'spacing.7'} />

      <Box display={'flex'} flexDirection={'column'}>
        <Text weight={'semibold'}>
          If Arrear calculation is{'  '}
          <Badge emphasis={'subtle'} color={'information'}>
            Disabled
          </Badge>
        </Text>
        <Box display={'flex'} flexDirection={'column'} gap={'spacing.4'}>
          <Text size="small" color={'surface.text.gray.muted'}>
            The component's value will not adjust for prior month corrections.
          </Text>
          <Text size="small" color={'surface.text.gray.muted'}>
            Example:
          </Text>
          <List size={'small'} variant={'unordered'}>
            <ListItem>
              <ListItemText color={'surface.text.gray.muted'}>
                In the same case, if arrears are disabled for the Canteen Charges component, no
                additional deduction will be recovered for the LOP reversal. The deduction will
                continue based on current month's attendance only."
              </ListItemText>
            </ListItem>
          </List>
        </Box>
      </Box>
    </Box>
  );
};

export default ArrearsInfo;
